export var formatDigit=function(num){if(num>=10){return num.toString()}return"0".concat(num)};
//# sourceMappingURL=formatDigit.js.map